// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__359sL","label":"Completed_label__2lLf1"};